






















































import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import ContactUs from '@/components/ContactUs.vue';
// 首页
import Banner from '@/components/home/Banner.vue';
import Solution from '@/components/home/Solution.vue';
import Introduction from '@/components/home/Introduction.vue';
import Custom from '@/components/home/Custom.vue';
import Ecology from '@/components/home/Ecology.vue';
import Broadcast from '@/components/home/Broadcast.vue';
import Hardware from '@/components/home/Hardware.vue';
import News from '@/components/home/News.vue';
import Cooperation from '@/components/home/Cooperation.vue';
// 新闻动态
import NewsList from '@/components/news/NewsList.vue';
import NewsDetail from '@/components/news/NewsDetail.vue';
// 回到顶部
import BackTop from '@/components/common/BackTop.vue';
import ImgPage from '@/components/home/ImgPage.vue';

import { navbarMap } from '@/utils/enumeration';
import { querySelector } from '@/utils/dom.js';
import {
  getConsumerMenuList,
  getConsumerList,
  getModule8,
  getModule1,
  getModule2,
  getModule3,
  getModule4,
  getModule5,
  getModule6,
  getModule7,
  getNewsList,
  getWebpage
} from '@/api/index';
// 导航组件数据接口类型
interface headerListInterface {
  name: string; //名称
  id: string; // 对应组件id
  type: number; //导航跳转类型
  anchor: string; //对应组件id
  offsetTop: number; //距离顶部的距离
  data: object; //导航数据
  children: []; //二级导航
  component: any; //导航对应组件
}
@Component({
  components: {
    Header,
    ContactUs,
    // home
    Banner,
    Solution,
    Introduction,
    Custom,
    Ecology,
    Broadcast,
    Hardware,
    News,
    Cooperation,
    // news
    NewsList,
    NewsDetail,
    // common
    BackTop,
    ImgPage
  }
})
export default class Home extends Vue {
  public componentsMap = {
    // 组件枚举值
    banner: Banner,
    introduction: Introduction,
    custom: Custom,
    ecology: Ecology,
    broadcast: Broadcast,
    hardware: Hardware,
    cooperation: Cooperation,
    contact: ContactUs,
    solution: Solution
  };
  public headerList: headerListInterface[] = [
    //导航组件数据
    {
      name: '首页',
      id: 'banner',
      type: 0,
      anchor: '0',
      offsetTop: 0,
      data: {},
      children: [],
      component: Banner
    }
  ];
  public isMobile: boolean = false; // 是否是移动端
  public showType: number = 1; // 1首页 2新闻列表 3新闻详情   4 新页面
  public activeIndex: number = 0; //当前激活的index
  public oldHomeActiveIndex: number = 0; //上一次首页激活的index
  public newsId: number = 0; //新闻详情ID
  public scrollTopPrev: number = 0; //上次的scrollTop
  public isDown: boolean = false; //默认向下滚动
  public homeData: object = {
    // 首页数据
    banner: [],
    solution: {
      companyProfile1: {
        fileList: []
      },
      companyProfile2: {
        fileList: []
      }
    },
    introduce: {
      companyShow: {},
      busShowList: []
    },
    custom: {},
    ecology: {
      platformList: []
    },
    broadcast: {},
    hardware: {},
    cooperation: {},
    contactUs: {
      imageList: []
    },
    news: {
      list: []
    }
  };
  public picUrlList: string[] = []
  created() {
    if (window.innerWidth < 800) {
      this.isMobile = true;
    }
    // 获取接口数据
    this.getData();
  }
  public async getData() {
    await Promise.all([
      getConsumerMenuList().then((res: any) => {
        if (res.code === 200) {
          res.data.forEach((item) => {
            let component = '',
              id = '';
            if (item.type === null && item.children && item.children.length) {
              const child = item.children.find((res) => res.type === 0);
              if (child) {
                id = navbarMap[child.anchor];
                component = this.componentsMap[navbarMap[child.anchor]];
              }
            } else {
              id = item.type === 0 ? navbarMap[item.anchor] : '';
              component = item.type === 0 ? this.componentsMap[navbarMap[item.anchor]] : '';
            }
            this.headerList.push({
              name: item.title,
              id: id,
              type: item.type,
              anchor: item.anchor,
              component: component,
              offsetTop: -1,
              children: item.children,
              data: {}
            });
          });
        }
      }),
      getConsumerList().then((res: any) => {
        // banner数据
        if (res.code === 200) {
          (this.homeData as any).banner = res.data;
        }
      }),
      getModule8().then((res: any) => {
        // 衣联网数据
        if (res.code === 200) {
          (this.homeData as any).solution = res.data.ylwShow;
        }
      }),
      getModule1().then((res: any) => {
        // 公司介绍数据
        if (res.code === 200) {
          (this.homeData as any).introduce = res.data;
        }
      }),
      getModule2().then((res: any) => {
        // 服装定制数据
        if (res.code === 200 && res.data.clothingFile) {
          (this.homeData as any).custom = res.data.clothingFile;
        }
      }),
      getModule3().then((res: any) => {
        // 洗护生态数据
        if (res.code === 200) {
          (this.homeData as any).ecology = res.data;
        }
      }),
      getModule4().then((res: any) => {
        // 众播基地数据
        if (res.code === 200 && res.data.liveFile) {
          (this.homeData as any).broadcast = res.data.liveFile;
        }
      }),
      getModule5().then((res: any) => {
        // 依联硬件数据
        if (res.code === 200) {
          (this.homeData as any).hardware = res.data;
        }
      }),
      getModule6().then((res: any) => {
        // 合作伙伴数据
        if (res.code === 200) {
          (this.homeData as any).cooperation = res.data;
        }
      }),
      getModule7().then((res: any) => {
        // 联系我们数据
        if (res.code === 200) {
          (this.homeData as any).contactUs = res.data;
        }
      }),
      getNewsList({ isTop: true }).then((res: any) => {
        // 新闻动态数据
        if (res.code === 200) {
          (this.homeData as any).news = res.data;
        }
      })
    ]);
    // this.$nextTick(() => {
    setTimeout(() => {
      // dom加载完后获取各个模块的offsetTop
      this.headerList.map((item, index) => {
        if (index === 0) {
          item.offsetTop = 0;
        } else {
          if (item.id && querySelector(`#${item.id}`)) {
            const offsetTop = querySelector(`#${item.id}`).offsetTop;
            item.offsetTop = offsetTop;
          }
        }
      });
    }, 1000);
  }

  // 切换导航
  public changeTab(index: number) {
    this.showType = 1;
    this.activeIndex = this.headerList.findIndex((res) => res.id === navbarMap[index]);
    this.$nextTick(() => {
      //模拟锚点跳转
      querySelector(`#${navbarMap[index]}`).scrollIntoView({
        behavior: 'smooth'
      });
    });
  }
  // 跳转到首页
  public jumpToHome() {
    this.activeIndex = this.oldHomeActiveIndex;
    this.showType = 1;
  }
  // 跳转 新闻列表
  public showNewsList(type) {
    // type 1 首页跳转新闻列表  2 新闻详情跳转列表

    window.scrollTo({
      top: 0,
    });
    if (type === 1) {
      this.oldHomeActiveIndex = this.activeIndex;
    }
    this.activeIndex = this.headerList.findIndex((res) => res.type === 1);
    this.showType = 2;
    this.$nextTick(() => {
      this.isDown = false;
      this.newsListToTop();
    });
  }
  // 跳转 新闻详情
  public jumpTodetail(newsId: number, type:number) {
    // type 1 首页跳转新闻列表  2 新闻详情跳转列表
    if (type === 1) {
      this.oldHomeActiveIndex = this.activeIndex;
    }
    this.showType = 3;
    this.newsId = newsId;
    this.activeIndex = this.headerList.findIndex((res) => res.type === 1);
    this.$nextTick(() => {
      this.isDown = false;
      (this.$refs.content as any).scrollTop = 0;
    });
  }
  public newsListToTop() {
    (this.$refs.newsList as any).scrollTo(0, 0);
  }
  // 首页滚动条事件
  public mainContentScroll(e: object) {
    const currentScrollTop = (e as any).target.scrollTop,
      scrollTop = currentScrollTop + 50;
    this.headerList.forEach((res, index) => {
      if (index === this.headerList.length - 1) {
        if (res.offsetTop >= 0 && res.offsetTop < scrollTop) {
          this.activeIndex = index;
        }
      } else {
        if (
          res.offsetTop >= 0 &&
          res.offsetTop < scrollTop &&
          (this.headerList[index + 1].offsetTop > scrollTop || this.headerList[index + 1].offsetTop < 0)
        ) {
          this.activeIndex = index;
        }
      }
    });
    this.computedHeaderShowOrHide(e);
  }
  // 新闻动态滚动条事件
  public newsContentScroll(e: object) {
    this.computedHeaderShowOrHide(e);
  }
  // 导航菜单上滑显示 下滑隐藏
  public computedHeaderShowOrHide(e: object) {
    const currentScrollTop = (e as any).target.scrollTop;
    this.isDown = currentScrollTop < 80 ? false : currentScrollTop - this.scrollTopPrev > 0;
    this.scrollTopPrev = currentScrollTop;
  }

  /**
   * 新页面
   * @param type
   */
  public jumpNewPage(id: String) {
    this.showType = 4;
    getWebpage({ id: id }).then((res:any) => {
      if ( res.code === 200 ) {
        this.picUrlList = res.data.picUrlList
      }
    })

    window.scrollTo({
      top: 0,
    });
  }
}
